/**
 * Admin Settings Service
 * Handles all settings-related admin API calls
 */

import { getApi, updateApi, postApi } from '../adminApi';

/**
 * Get all settings
 * @returns {Promise}
 */
export const getSettings = async () => {
  return getApi('settings');
};

/**
 * Update settings
 * @param {Object} settings - Settings data
 * @returns {Promise}
 */
export const updateSettings = async (settings) => {
  return updateApi('settings', settings);
};

/**
 * Change admin password
 * @param {Object} data - { currentPassword: string, newPassword: string }
 * @returns {Promise}
 */
export const changeAdminPassword = async (data) => {
  return postApi('change-password', data);
};

